<template>
  <div class="full-height">
    <div :class="isMobile ? 'index-box2' : 'index-box'">
      <el-container class="full-height" :class="isMobile ? 'row' : 'column'">
        <!-- header区域 -->
        <template v-if="isMobile">
          <el-aside v-if="showLeftMenu" class="box2-aside" width="80px">
            <MenuH5 @navName="getNavName" @mentList="transferMentList" />
          </el-aside>
        </template>
        <el-header v-else>
          <CaseHeads />
          <!-- @navName="getNavName" -->
        </el-header>

        <el-container class="col" :class="{ 'full-height': isMobile }">
          <template v-if="!isMobile">
            <el-aside class="index-aside">
              <CaseMenu
                @navName="getNavName"
                @navNameList="getNavNameList"
                @mentList="transferMentList"
              ></CaseMenu>
            </el-aside>
            <el-container style="max-width: 440px" v-if="TimeLineShow">
              <TimeLineImg :LineNumber="LineNumber" />
            </el-container>
          </template>

          <el-main
            class="no-padding column"
            :class="{ 'cont-ainer': !isMobile }"
          >
            <UserLogin v-if="isMobile"></UserLogin>
            <div class="col router-container">
              <!-- @thesisTimeLine="thesisTimeLine" @TimeLineNumber="msgTimeLineNumber" -->
              <router-view
                :infoName="navName"
                :transferMent="transferMent"
                :contList="contList"
              ></router-view>
            </div>
          </el-main>
        </el-container>

        <!-- 右悬浮 -->
        <suspension v-if="!isMobile"></suspension>
      </el-container>
    </div>
  </div>
</template>

<script>
import CaseHeads from '../../components/caseHeads/caseHeads.vue'
import CaseMenu from '../../components/caseMenu/caseMenu.vue'
import UserLogin from '@/components/userLogin/index.vue'
import MenuH5 from '@/components/menuH5/menuH5.vue'
import MenuFoot from '@/components/menuFoot/index.vue'
import suspension from '@/components/suspension/suspension.vue'
import LeftMenu from '@/views/user_promot/components/LeftMenu/index.vue'
import RequestlogApi from '@/api/requestlog'
import TimeLineImg from '@/components/TimelineImg'
import { EventBus } from '@/utils/eventBus'
import { SCREEN_LIMIT_VALUE } from '@/assets/constant.json'
export default {
  components: {
    LeftMenu,
    suspension,
    MenuFoot,
    MenuH5,
    UserLogin,
    CaseHeads,
    CaseMenu,
    TimeLineImg,
  },
  data() {
    return {
      // activeValue: 10,
      transferMent: [],
      windowWidth: document.body.clientWidth,
      isMobile: false,
      navName: '', //保存路由title
      contList: '', //保存路由list
      showLeftMenu: true,
      showLeftList: true,
      LineNumber: 1,
      TimeLineShow: false,
    }
  },
  created() {
    this.resize()
    this.report()
  },
  mounted() {
    EventBus.$on('windowResize', ({ windowWidth, isMobile }) => {
      this.windowWidth = windowWidth
      // this.isMobile = isMobile
      this.resize()
    })
  },
  watch: {
    $route(to, from) {
      // 这里会在路由路径变化时执行
      localStorage.removeItem('orderId')
      localStorage.removeItem('creationDocCode')
      this.toPath(to.path)
      // this.showLine(to.path)
    },
  },
  methods: {
    resize() {
      this.isMobile = this.windowWidth < SCREEN_LIMIT_VALUE

      // 是否显示左侧菜单
      let toPath = this.$route.path
      this.showLeftMenu = toPath !== '/index/promot'
    },
    transferMentList(val) {
      this.transferMent = val
      this.toPath(val[0].url)
      this.$router.push(val[0].url)
      // let toPath = this.$route.path
      // this.toPath(toPath)
    },
    getNavName(name) {
      this.navName = name
    },
    getNavNameList(item) {
      this.contList = item
    },
    toPath(path) {
      this.showLeftList = false
      if (path === '/index/IntelligentPay') {
        this.LineNumber = 2 + '.jpg'
        this.TimeLineShow = true
      } else if (path === '/index/paySuccess' || path === '/index/order') {
        this.LineNumber = 3 + '.jpg'
        this.TimeLineShow = true
      } else if (
        path === '/index/caseLibrary' ||
        path === '/index/pptLibrary' ||
        path === '/index/promot'
      ) {
        this.LineNumber = 1 + '.jpg'
        this.TimeLineShow = false
      } else {
        this.showLeftList = true
        this.LineNumber =
          path === '/index/ppt_defense'
            ? 'internship_report.png'
            : path.split('/index/')[1] + '.png'
        this.TimeLineShow = true
      }
    },
    // showLine(path){
    //   this.transferMent.some(item => {
    //     if(path === item.url){
    //       this.TimeLineShow = true
    //       this.LineNumber = 1
    //     }else if(path === '/index/IntelligentPay'){
    //       this.TimeLineShow = true
    //       this.LineNumber = 2
    //     }else if(path === '/index/paySuccess' || path === '/index/order'){
    //       this.TimeLineShow = true
    //       this.LineNumber = 3
    //     }else if(path === '/index/caseLibrary' || path === '/index/pptLibrary' || path === '/index/promot'){
    //       this.TimeLineShow = false
    //       this.LineNumber = 1
    //     }
    //   })
    // },
    // 上报日志
    report() {
      let data = {
        type: 1,
        channelCode: '',
        description: '',
      }
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      RequestlogApi.report(data, key, time, infoMd5)
        .then((res) => {
          // console.log(res.data)
        })
        .catch(() => {})
    },
    msgTimeLineNumber(num) {
      setTimeout(() => {
        this.TimeLineShow = true
        this.LineNumber = num
      }, 200)
    },
    thesisTimeLine(type) {
      this.TimeLineShow = type
      this.LineNumber = 1
    },
  },
}
</script>

<style scoped lang="less">
.index-box {
  display: block;
  height: 100%;
  width: 100%;
  .index-aside {
    width: auto !important;
    overflow: initial;
  }
  .cont-ainer::before {
    position: absolute;
    z-index: -1;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(160deg, #7768ff, #ffffff, #ffffff);
    opacity: 0.1;
  }
}
.index-box2 {
  display: block;
  width: 100%;
  height: 100%;
  background: url(../../assets/images/bg.jpg) no-repeat right 0;
  background-size: cover;
  .box2-aside {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #ffffff;
    box-shadow: 3px 0 5px rgba(51, 185, 255, 0.1);
  }
}
.router-container {
  margin-bottom: 10px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }
}
</style>
